import * as Yup from "yup";

const colecaoValidator = Yup.object().shape({
  descricao: Yup.string().required("Descrição"),
  ativado: Yup.boolean().optional().nullable(),
});

export default colecaoValidator;
